// // Action names should be imported from their respective action modules
import {
    COURSE_MULTIMEDIA_BEGIN,
    COURSE_MULTIMEDIA_SUCCESS,
    COURSE_MULTIMEDIA_FAILURE,
    COURSE_MULTIMEDIA_CLEAR
} from '../actions/CourseMultimediaActions';

// Example initial state
const initialState = {
    item: {},
    isLoading: false,
    error: ''
};

// Return a new state object with updated attributes
export default function CourseMultimediaReducer(state = initialState, action) {
    switch (action.type) {
        case COURSE_MULTIMEDIA_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case COURSE_MULTIMEDIA_SUCCESS:
            return {
                ...state,
                item: action.payload.data,
                isLoading: false,
                error: ''
            }
        case COURSE_MULTIMEDIA_FAILURE:
            return {
                ...state,
                error: action.payload.error,
                isLoading: false
            }
        case COURSE_MULTIMEDIA_CLEAR:
            return {
                ...state,
                item: {},
                isLoading:false
            }
        default:
            return state;
    }
};


export const courseMultimediaError = state => {
    return state.error;
}

export const courseMultimediaIsLoading = state => {
    return state.isLoading;
}

export const courseMultimedia = state => {
    return state.item;
}